import { useEffect, useState } from 'react'

import DeviceDetector from 'device-detector-js'

import { T } from '../../i18n/index.js'
import { COMMAND_BAR_HOTKEYS } from '../CommandBar.constants.js'
import { CommandBarMode } from '../CommandBar.types.js'
import { useCommandBar } from '../CommandBarContext.js'

import { HotkeyGuideItem, KeyLabel } from './HotkeyGuideItem.js'

const keys = {
  enter: 'enter',
  esc: 'esc',
}

export const HotkeysGuide = () => {
  const { open, searchOptions } = useCommandBar()
  const [isDesktopDevice, setIsDesktopDevice] = useState(false)
  const deviceDetector = new DeviceDetector()

  useEffect(() => {
    const device = deviceDetector.parse(navigator.userAgent)

    if (device.device?.type === 'desktop') {
      setIsDesktopDevice(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!isDesktopDevice) {
    return null
  }

  const navigationKeys: KeyLabel[] = [
    { type: 'icon', value: 'arrow-up' },
    { type: 'icon', value: 'arrow-down' },
  ]

  const enterKey: KeyLabel[] = [{ type: 'hotkey', value: keys.enter }]

  const commandsKey: KeyLabel[] = [
    { type: 'label', value: COMMAND_BAR_HOTKEYS.COMMANDS.label },
  ]

  const searchKey: KeyLabel[] = [
    { type: 'label', value: COMMAND_BAR_HOTKEYS.SEARCH.label },
  ]

  const escKey: KeyLabel[] = [{ type: 'hotkey', value: keys.esc }]

  return (
    <footer className="flex px-4 lg:px-5 gap-4 py-2 border-t bg-surface-disabled text-xs cursor-default flex-wrap">
      <HotkeyGuideItem
        keyLabels={navigationKeys}
        description={
          <T id="CommandBar.Hotkeys.Navigate" defaultMessage="to navigate" />
        }
      />

      <HotkeyGuideItem
        keyLabels={enterKey}
        description={
          <T id="CommandBar.Hotkeys.Select" defaultMessage="to select" />
        }
      />

      {searchOptions.mode === CommandBarMode.SEARCH && (
        <HotkeyGuideItem
          keyLabels={commandsKey}
          description={
            <T
              id="CommandBar.Hotkeys.CommandsLists"
              defaultMessage="to access commands list"
            />
          }
          onClick={() =>
            open({ searchOptions: { mode: CommandBarMode.COMMANDS } })
          }
        />
      )}

      {searchOptions.mode === CommandBarMode.COMMANDS && (
        <HotkeyGuideItem
          keyLabels={searchKey}
          description={
            <T id="CommandBar.Hotkeys.Search" defaultMessage="to search" />
          }
          onClick={() =>
            open({
              searchOptions: { mode: CommandBarMode.SEARCH },
            })
          }
        />
      )}

      <HotkeyGuideItem
        keyLabels={escKey}
        description={
          <T id="CommandBar.Hotkeys.Close" defaultMessage="to close" />
        }
      />
    </footer>
  )
}
